/**
 * External dependencies
 */
import { get } from 'lodash';

export const getLocationId = state => get(state, 'ui.locationModal.locationId', "");